import { todayNews } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  实锤: "bg-primary-100 text-primary-900",
  发酵: "bg-accent-100 text-accent-900",
  待挖: "bg-secondary-100 text-secondary-900",
};

export default function TodaySection() {
  return (
    <section id="today" className="bg-background-100/50 border-y border-background-200/60 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 text-primary-900 px-3 py-1 text-xs font-semibold">
              <i className="ri-file-list-3-line"></i> 今日更新抢先看
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl font-black text-foreground-950 tracking-tight">
              今天值得二刷的新瓜
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
              早中晚各归纳一轮，把吵到一半的话题和坐实的内容一起摆上来，补课从这儿开始。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 shrink-0">
            更新于今天 09:40 <i className="ri-sparkling-2-line text-accent-500"></i>
          </div>
        </div>

        {/* 封面驱动卡片 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {todayNews.map((n) => (
            <article
              key={n.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-50 hover:border-primary-300 transition cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={n.cover}
                  alt={`${n.category}快讯：${n.title}`}
                  title={`擦边吃瓜 · ${n.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 text-foreground-800 px-2 py-1 text-xs font-semibold backdrop-blur">
                  {n.category}
                </span>
                <span className={`absolute right-3 top-3 inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold ${statusStyle[n.status]}`}>
                  <i className="ri-fire-line"></i> {n.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="text-[15px] md:text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition">
                  {n.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{n.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i> {n.read}</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i> {n.comments}</span>
                  <span className="ml-auto text-primary-700 font-medium inline-flex items-center gap-1 whitespace-nowrap">
                    看详情 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}